/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ActionDefaultController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ActionDefaultController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class ActionDefaultController extends cls.ControllerBase /** @lends classes.ActionDefaultController.prototype */ {
    static __name = "ActionDefaultController";

    constructor(bindings) {
      super(bindings);
    }

    /**
     * @inheritDoc
     */
    _initBehaviors() {
      super._initBehaviors();

      // vm behaviors
      this._addBehavior(cls.ActionDefaultAcceleratorVMBehavior);
    }

    /**
     * @inheritDoc
     */
    createWidget() {
      return null;
    }
  }

  cls.ActionDefaultController = ActionDefaultController;
  cls.ControllerFactory.register("ActionDefault", cls.ActionDefaultController);
});
